exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block-divider {\n  padding: 50px 20px;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n}\n.block-divider .divider {\n  width: 100%;\n  height: 2px;\n  background-color: #45A8F7;\n  position: relative;\n}\n.block-divider .divider .divider-number {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: white;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  font-size: 20px;\n  font-weight: 600;\n  color: #FFF;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}", ""]);

// exports
